import { Component, forwardRef, OnInit } from '@angular/core';
import { ColumnBase } from '@progress/kendo-angular-grid';
import { WlmColumnComponent } from '../../wlm-column/wlm-column.component';

@Component({
    selector: 'wlm-image-column',
    templateUrl: './image-column.component.html',
    styleUrls: ['./image-column.component.scss'],
    providers: [
        {
            provide: ColumnBase,
            useExisting: forwardRef(() => ImageColumnComponent),
        },
    ],
    standalone: false
})
export class ImageColumnComponent extends WlmColumnComponent implements OnInit {}
